import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import GlassCard from '../components/ui/GlassCard';
import API from '../services/api';
import { toast } from 'react-toastify';

const Login = () => {
  const [mode, setMode] = useState('email');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = mode === 'email' ? { email, password } : { phone, password };
      const res = await API.post('/auth/login', payload);
      localStorage.setItem('vibe_token', res.data.token);
      localStorage.setItem('vibe_user', JSON.stringify(res.data.user));
      toast.success('Welcome back!');
      navigate('/discover');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      background: '#08080C', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: -100, right: -100,
        width: 300, height: 300, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,61,113,0.1), transparent)',
        filter: 'blur(60px)',
      }} />

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '60px 28px 40px', justifyContent: 'center' }}>
        <div style={{ marginBottom: 40 }}>
          <h1 style={{
            fontSize: 34, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 8,
          }}>Welcome back</h1>
          <p style={{ fontSize: 15, color: '#71717A' }}>Sign in to continue your vibe</p>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
          {[{ id: 'email', label: 'Email' }, { id: 'phone', label: 'Phone' }].map(m => (
            <button key={m.id} onClick={() => setMode(m.id)} style={{
              flex: 1, padding: '12px', borderRadius: 12, border: 'none',
              background: mode === m.id ? 'rgba(255,61,113,0.12)' : 'rgba(255,255,255,0.04)',
              color: mode === m.id ? '#FF3D71' : '#71717A',
              fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter',
              border: `1px solid ${mode === m.id ? 'rgba(255,61,113,0.3)' : 'rgba(255,255,255,0.06)'}`,
              transition: 'all 0.2s',
            }}>{m.label}</button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          {mode === 'email' ? (
            <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" />
          ) : (
            <Input label="Phone Number" type="tel" value={phone} onChange={e => setPhone(e.target.value)}
              placeholder="+91 98765 43210" />
          )}
          <Input label="Password" type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Enter your password" />

          <div style={{ textAlign: 'right', marginBottom: 24 }}>
            <a href="#" style={{ fontSize: 13, color: '#FF3D71', fontWeight: 500 }}>Forgot password?</a>
          </div>

          <Button type="submit" fullWidth size="lg" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>

        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
            <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.06)' }} />
            <span style={{ fontSize: 12, color: '#52525B' }}>or continue with</span>
            <div style={{ flex: 1, height: 1, background: 'rgba(255,255,255,0.06)' }} />
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            {[
              { label: 'Google', icon: 'G', color: '#4285F4' },
              { label: 'Apple', icon: '', color: '#FFFFFF' },
            ].map(s => (
              <button key={s.label} style={{
                flex: 1, padding: '14px', borderRadius: 14, border: '1px solid rgba(255,255,255,0.08)',
                background: 'rgba(255,255,255,0.04)', color: s.color,
                fontSize: 16, fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                transition: 'all 0.2s',
              }}>
                {s.label === 'Google' ? <span style={{ fontWeight: 700 }}>G</span> : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                )}
                {s.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <p style={{ textAlign: 'center', padding: '0 28px 32px', fontSize: 14, color: '#71717A' }}>
        Don't have an account? <Link to="/signup" style={{ color: '#FF3D71', fontWeight: 600 }}> Sign Up</Link>
      </p>
    </div>
  );
};

export default Login;
